"use client";
import * as NavigationMenu from "@radix-ui/react-navigation-menu";

import React, { PropsWithChildren } from "react";
import { ListItemType } from "./types";
import { Link } from "gatsby";
import clsx from "clsx";

export type listItemProps = ListItemType & {
  className?: string;
} & PropsWithChildren;

const ListItem = React.forwardRef<HTMLAnchorElement, listItemProps>(
  function ListItem({ className, children, title, ...props }, forwardedRef) {
    return (
      <li className=" px-2 hover:bg-blue-300">
        <NavigationMenu.Link asChild>
          <Link
            className={clsx(
              "block select-none rounded-[6px] p-3 text-[15px] leading-none no-underline outline-none transition-colors",
              className
            )}
            to={props.url}
            {...props}
            ref={forwardedRef}
          >
            <div className="text-white mb-[5px] font-medium leading-[1.2]">
              {title}
            </div>
            <p className="text-mauve11 leading-[1.4]">{children}</p>
          </Link>
        </NavigationMenu.Link>
      </li>
    );
  }
);

export default ListItem;
